/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function ReviewChangesRequestedFilled({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18" {...props}><path fill="#E10202" d="M7.828.518a2.35 2.35 0 0 1 2.344 0l5.586 3.225a2.35 2.35 0 0 1 1.172 2.032v6.45c0 .838-.447 1.612-1.172 2.03l-5.586 3.227a2.35 2.35 0 0 1-2.344 0L2.24 14.256a2.35 2.35 0 0 1-1.171-2.032v-6.45c0-.838.447-1.612 1.171-2.03z" /><path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.271} d="m5.937 5.985 6.128 6.129m-6.13-.099 6.128-6.129" /></svg>;
}
;